var account = "Λογαριασμός";
var accountSettings = "Ρυθμίσεις λογαριασμού";
var charging = "Φόρτιση";
var contactInfo = "Στοιχεία επικοινωνίας";
var dashboard = "Ταμπλό";
var home = "Αρχική";
var myProducts = "Τα προϊόντα μου";
var orderHistory = "Ιστορικό παραγγελιών";
var paymentMethod = "Τρόπος πληρωμής";
var profileSettings = "Ρυθμίσεις προφίλ";
var referAndEarn = "Συστήστε και κερδίστε";
var signOut = "Αποσύνδεση";
var el_GR = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, el_GR as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
